<template>
    <div class="container my-5">
		<section class="categories-section mb-4 pb-2">
            <div class="container h-100">
                <div class="w-100 text-center py-4">
                    <h4 class="section-title" v-html="$t('homepage.categories-section.title')"></h4>
                </div>
                <div v-if="categories.length > 0" class="w-100 d-flex flex-wrap pt-4">
                    <div
						v-for="item in categories"
						:key="item.id"
						class="categories-card-block"
                    >
						<router-link
							:to="{ name: 'category', params: { slug: item.slug } }"
							class="d-flex flex-column flex-md-row p-4 rounded-4 bg-white card-shadow router-link-class category-router-link h-100"
						>
							<div class="categories-card-content order-last order-md-first">
								<h5 class="bold mb-3 v-html-card-header">{{ item.name }}</h5>
								<p class="mb-0 v-html-card-description" v-html="item.summary || item.description"></p>
							</div>
							<div class="categories-card-image order-first order-md-last d-flex align-items-center">
								<img :src="item.image" alt="" class="w-100 pb-4 pb-md-0">
							</div>
                        </router-link >
                    </div>
                </div>
            </div>
        </section>
	</div>
</template>
<script>

import { mapState } from 'vuex'
export default {
	name: 'AllCategories',
	data () {
		return {
			categoriesTest: [
				{
					id: 1,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/1'
				},
				{
					id: 2,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/2'
				},
				{
					id: 3,
					title: 'title',
					content: 'something here just to fill the content of the categories card... ye they want more words...',
					image: require('@/assets/images/screw-wall-plug.png'),
					to: '/category/3'
				},
			],
		}
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories
		})
	}
}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';

// major classes
.section-title {
	font-weight: 800;
	line-height: 1.65;
}

.section-title ::v-deep span {
	color: $secondary;
	font-weight: 900;
}

// categories section
.categories-section {
    // height: 350px;

    .categories-card-block {
        width: 32%;
		padding: 0 0 30px;
		margin-left: 14px;

		@media (max-width: 1200px) {
			margin-left: 12px;
		}
        @media (max-width: 992px) {
            width: 48%;
        }
		@media (max-width: 768px) {
			margin-left: 8px;
		}
		@media (max-width: 538px) {
			width: 46%;
			margin-left: 8px;
		}
		@media (max-width: 425px) {
			width: 96%;
			margin: 0 auto;
		}

		.category-router-link {
			transition: transform 0.15s ease, box-shadow 0.15s ease;
			&:hover {
				transform: translateY(-3px);
				box-shadow: -5px 2px 50px 3px #f0f0f0 ;
			}
		}

		// for other language
        [dir='ltr'] & {
			margin-left: 0px;
            margin-right: 14px;

            @media (max-width: 1200px) {
				margin-right: 12px;
			}

			@media (max-width: 768px) {
				margin-right: 10px;
			}
			@media (max-width: 538px) {
				width: 46%;
				margin-right: 8px;
			}
			@media (max-width: 425px) {
				width: 96%;
				margin: 0 auto;
			}
        }

		.categories-card-content {
			width: 65%;
			@media (max-width: 992px) {
				width: 100%
			}

			p {
				line-height: 1.35;
			}
		}
		.categories-card-image {
			width: 35%;
			@media (max-width: 992px) {
				width: 100%
			}
		}
    }

}
</style>
<style lang="scss">
	.v-html-card-header {
		@media (max-width: 425px) {
			font-size: 16px;
		}
	}

	.v-html-card-description {
		@media (max-width: 475px) {
			font-size: 14px;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
</style>